import base from 'components/base'
import componentInit from 'components/componentInit'
import $ from 'jquery'

class help extends base
{
  elements = {
    container: null,
    button: null,
    text: null
  }

  constructor(element)
  {
    super()

    this.elements.container = $(element).get(0)
    this.elements.button = $(this.elements.container).children('button').get(0)
    this.elements.text = $(this.elements.container).children('.text').get(0)

    this.bindEvents()
  }

  bindEvents()
  {
    $(this.elements.button).on('click.'+ module.id, (event) =>
    {
      event.preventDefault()
      this.toggleHelpText()
    })
  }

  toggleHelpText()
  {
    if($(this.elements.text).is(':hidden'))
      $(this.elements.text).show()
    else
      $(this.elements.text).hide()
  }
}

componentInit.prototype.callbacks[module.id] = function(parentElement)
{
  let elements = $(parentElement).find('.help').get()
  for(let element of elements)
    new help(element)
}

export default help



// WEBPACK FOOTER //
// ./vendor/response200/kustantajat/applications/publicFrontend/scripts/components/help.js